(function () {
    'use strict';
    app.service('discountCodeManagementService', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {
        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deferred;

        this.getDiscountCodes = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getDiscountCodes", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getDiscountCodesReport = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getDiscountCodesReport", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getDiscountData = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getDiscountData?discountCode=" + data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.createDiscountCode = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/createDiscountCode", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.updateDiscountCode = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/updateDiscountCode", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.deleteDiscountCode = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/deleteDiscountCode", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }
    }
    ]);
})();